import {combineReducers} from 'redux';
import { connectRouter } from 'connected-react-router'
import user from "./user";
import agentsList from "./agentsList";
import usersList from "./usersList";
import newSolicitor from "./newSolicitor";
import manageSolicitorAccount from "./manageSolicitorAccount";
import solicitorGroup from "./solicitorGroup";
import applicationFormReferralSettings from "./applicationFormReferralSettings";
import newApplication from "./newApplication";
import applicationsAndPolicies from "./applicationsAndPolicies";
import applicationPolicy from "./applicationPolicy";
import newUser from './newUser';
import updateTab from "./updateTab";
import overviewTab from "./overviewTab";
import notifications from './notifications';
import lawsysFirms from './lawsysFirms';
import toba from './toba';
import postedApplicationPage from "./postedApplicationPage";
import premiumSettings from "./premiumSettings";
import breachCausationCp from "./breachCausationCp";
import newApplicationFormMessage from "./newApplicationFormMessage";
import setUserPassword from "./setUserPassword";
import solicitorGroupsList from "./solicitorGroupsList";
import groups from "./groups";
import caseTypes from "./caseTypes";
import applicationStatuses from "./applicationStatuses";
import applicationAcceptedStatusesTransitions from "./applicationAcceptedStatusesTransitions";
import articleForm from "./articleForm";
import articlesList from "./articlesList";
import solicitorArticlesList from "./solicitorArticlesList";
import policyTab from "./policyTab";
import premiumSettingsWizard from "./premiumSettingsWizard";
import damages from "./damages";
import solicitorImages from "./solicitorImages";
import solicitorHomePageInfo from "./solicitorHomePageInfo";
import expenseTypes from "./expenseTypes";
import tobas from "./tobas";
import tobaList from "./tobaList";
import advancedDisbursementsForm from "./advancedDisbursementsForm";
import advancedDisbursements from "./advancedDisbursements";
import advancedDisbursementsList from "./advancedDisbursementsList";
import general from "./general";
import advanceDisbursementsTab from "./advanceDisbursementsTab";
import editingSettings from "./editingSettings";
import pendingChanges from "./pendingChanges";
import questionAnswersRevisions from "./questionAnswersRevisions";
import wordingCategories from "./wordingCategories";
import gplPolicyDocuments from "./gplPolicyDocuments";
import broker from "./broker";
import brokers from "./brokers";
import brokerFirms from "./brokerFirms";
import quote from "./quote";
import quotes from "./quotes";
import groupQuestionsSpec from "./groupSpec";
import stagedPremiums from './stagedPremiums';
import stagedPremiumsWizard from './stagedPremiumsWizard';
import internalAlerts from './internalAlerts';
import internalAlertForm from './internalAlertForm';
import submittedPolicy from './submittedPolicy';
import configuration from './configuration';
import externalPolicyUpdate from './externalPolicyUpdate';
import financialsTab from "./financialsTab";

	const rootReducer = (history) => combineReducers({
	stagedPremiumsWizard : stagedPremiumsWizard,
	stagedPremiums: stagedPremiums,
	internalAlerts,
	internalAlertForm,
	wordingCategories,
	gplPolicyDocuments,
	questionAnswersRevisions,
	pendingChanges,
	editingSettings,
    advanceDisbursementsTab,
	quotes,
	quote,
    brokerFirms,
	brokers,
	broker,
	general,
    advancedDisbursementsList,
	advancedDisbursements,
	advancedDisbursementsForm,
	tobaList,
	tobas,
	expenseTypes,
	solicitorHomePageInfo,
	solicitorImages,
	premiumSettingsWizard,
	router:connectRouter(history),
	articleForm: articleForm,
	articlesList: articlesList,
	policyTab: policyTab,
	groups,
	solicitorArticlesList,
	solicitorGroupsList,
    setUserPassword,
	postedApplicationPage,
	updateTab,
	newApplication,
	applicationFormReferralSettings,
	applicationsAndPolicies,
	solicitorGroup,
	manageSolicitorAccount,
	newSolicitor,
	agentsList,
	user,
	applicationPolicy,
	newUser,
	usersList,
	overviewTab,
	notifications,
	lawsysFirms,
	toba,
	premiumSettings,
	breachCausationCp,
	newApplicationFormMessage,
	caseTypes,
	applicationStatuses,
	applicationAcceptedStatusesTransitions,
	damages,
	groupQuestionsSpec,
	submittedPolicy,
	configuration,
	externalPolicyUpdate,
	financialsTab,
});

export default rootReducer;

